"use client";

import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { useCart } from '@/contexts/CartContext';
import CartButton from '@/components/cart/CartButton';
import CartModal from '@/components/cart/CartModal';

interface Product {
  code: string;
  name: string;
  type: string;
  image: string;
  alt: string;
}

interface Category {
  name: string;
  products: Product[];
}

const categories: Category[] = [
  {
    name: "CERAS Y SELLADORES",
    products: [
      { code: "3578", name: "3 EN 1 WAX / CERA LIQUIDA", type: "Cera Liquida", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560646/3578_exsil0.png", alt: "3 EN 1 WAX" },
      { code: "3577", name: "CARNAUBA PLUS PREMIUM LIQUID WAX / CERA LIQUIDA", type: "Cera Liquida", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560645/3577_zash4u.png", alt: "CARNAUBA LIQUID" },
      { code: "3576", name: "PASTE WAX / HYDROPHOBIC POLYMER", type: "Cera en Pasta", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560644/3576_miyrke.png", alt: "PASTE WAX" },
      { code: "3583", name: "CLEANER WAX PASTE 16 OZ", type: "Cera en Pasta", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560645/3583_yleyux.png", alt: "CLEANER WAX 16OZ" },
      { code: "2716", name: "CLEANER WAX PASTE 11 OZ", type: "Cera en Pasta", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560643/A-1214_urnllp.png", alt: "CLEANER WAX 11OZ" },
      { code: "1570", name: "LUBRISTAR SPRAY POLISH WAX 550 ML", type: "Cera en Spray", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560635/1570_r5soj3.png", alt: "LUBRISTAR WAX" }
    ]
  },
  {
    name: "LIMPIEZA Y LAVADO",
    products: [
      { code: "3087", name: "GAMUZA PEQUEÑA / 2835", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560643/3087_xzehie.png", alt: "GAMUZA PEQUEÑA" },
      { code: "3097", name: "SHAMPOO WATERMELON BUBBLEGUM 64OZ", type: "Jabón", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/3588_tztwuf.png", alt: "SHAMPOO" },
      { code: "1572", name: "TIRE SHINE LUBRISTAR", type: "Brillo", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560634/1572_rbsbvx.png", alt: "LUBRISTAR TIRE" },
      { code: "2826", name: "BUG TAR REMOVER", type: "Limpiador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560640/2826_uuarkp.png", alt: "BUG TAR" },
      { code: "3590", name: "HOT RIMS BLACK WHEEL CLEANER 24 OZ", type: "Limpiador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/3590_bbxvas.png", alt: "WHEEL CLEANER" },
      { code: "3589", name: "ULTIMATE WATER LESS WASH Y WAX 16 OZ", type: "Lavado sin Agua", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/3589_vnuvgd.png", alt: "WATERLESS WASH" },
      { code: "3657", name: "WATER SPOT / REMOVEDOR DE GOTAS SECA", type: "Limpiador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560640/3657_rdc1zg.png", alt: "WATER SPOT" }
    ]
  },
  {
    name: "GOMAS Y AROS",
    products: [
      { code: "1572", name: "TIRE SHINE LUBRISTAR", type: "Brillo", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560634/1572_rbsbvx.png", alt: "LUBRISTAR TIRE" },
      { code: "2871", name: "HOT SHINE TIRE SPRAY", type: "Brillo", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560638/2718_iktyua.png", alt: "HOT SHINE" },
      { code: "2723", name: "ENDURANCE TIRE GEL", type: "Brillo", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560639/2723_pox1ck.png", alt: "ENDURANCE GEL" },
      { code: "3588", name: "CERAMIC SHINE TIRE 16 OZ", type: "Brillo", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/3588_tztwuf.png", alt: "CERAMIC SHINE" },
      { code: "3594", name: "ULTIMATE INSANE SHINE FOAM", type: "Espuma", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560636/3594_lbbbne.png", alt: "INSANE SHINE" }
    ]
  },
  {
    name: "PROTECTORES Y RESTAURADORES",
    products: [
      { code: "3591", name: "CERAMIC RESTORER TRIM 16 OZ", type: "Restaurador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/3591_tfth59.png", alt: "CERAMIC TRIM" },
      { code: "2718", name: "MEGUIARS ULTIMATE PROTECTANT 12OZ", type: "Protector", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560638/2718_iktyua.png", alt: "ULTIMATE PROTECTANT" },
      { code: "2825", name: "ULTIMATE BLACK PLASTIC RESTORER (CREAM)", type: "Restaurador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560642/2825_bwusfo.png", alt: "BLACK CREAM" },
      { code: "3973", name: "Ultimate Black Restorer (Spray)", type: "Restaurador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772571404/LEAF_ROCKET_PRODUCTS_g54rlf.png", alt: "BLACK SPRAY" }
    ]
  },
  {
    name: "INTERIOR Y PIEL",
    products: [
      { code: "2872", name: "ALL SURFACE INTERIOR CLEANER", type: "Limpiador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560641/2872_h6l6v1.png", alt: "INTERIOR CLEANER" },
      { code: "3584", name: "ULTIMATE LEATHER DETAILER 16 OZ", type: "Protector", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560645/3584_e1ux1x.png", alt: "LEATHER DETAILER" },
      { code: "3582", name: "GOLD CLASS WIPES RICH LEATHER WIPES", type: "Toallitas", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560645/3582_uoeyev.png", alt: "GOLD CLASS WIPES" }
    ]
  },
  {
    name: "AIR REFRESHERS",
    products: [
      { code: "2359", name: "Air Refresher New Car", type: "Ambientador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560637/2359_ao4004.png", alt: "NEW CAR SCENT" },
      { code: "2359-2", name: "Air Refresher Black Chrome", type: "Ambientador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/2359_2_oxyl7f.png", alt: "BLACK CHROME SCENT" },
      { code: "2359-3", name: "Air Refresher Fiji Sunset", type: "Ambientador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560635/2359_3_itzlqb.png", alt: "FIJI SUNSET SCENT" },
      { code: "2359-4", name: "Air Refresher Summer Breeze", type: "Ambientador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560637/2359_4_enynqr.png", alt: "SUMMER BREEZE SCENT" }
    ]
  },
  {
    name: "ACCESORIOS Y HERRAMIENTAS",
    products: [
      { code: "1505", name: "LANILLAS", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560632/1505_u33imv.png", alt: "LANILLAS" },
      { code: "1822", name: "GAMUZA GRANDE/1088", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560634/1822_i2vktw.png", alt: "GAMUZA GRANDE" },
      { code: "3597", name: "APPLICATOR PADS", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560637/3597_qat4ly.png", alt: "APPLICATOR PADS" },
      { code: "2874", name: "MICROFIBER APPLICATOR / PAD DE APLICACION 2EN1/X-3080", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560641/2874_sq2xyn.png", alt: "MICROFIBER APPLICATOR" },
      { code: "2877", name: "LANILLA MICROFIBRA GOODYEAR", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560646/2877_eqap5x.png", alt: "MICROFIBRA GOODYEAR" },
      { code: "2839", name: "ESPUMA LIMPIA TAPICES GOODYEAR", type: "Limpiador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560641/2839_z9si7f.png", alt: "GOODYEAR FOAM" },
      { code: "1692", name: "LIMPIADOR EN ESPUMA LUBRISTAR/8921", type: "Limpiador", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772560636/1692_bufmt1.png", alt: "LUBRISTAR ESPUMA" },
      { code: "X-210200", name: "Hybrid Wash Mitt", type: "Accesorio", image: "https://res.cloudinary.com/dasaxd4yj/image/upload/v1772233691/C%C3%B3digo__X-210200_Producto__Hybrid_Wash_Mitt_Tipo__Guante_de_Microfibra_tfmzsy.png", alt: "WASH MITT" }
    ]
  }
];




const CompleteCatalogSection: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>("Todos");
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { addToCart } = useCart();

  const getWhatsAppLink = (productName: string, productCode: string) => {
    const message = `Hola, me interesa el producto: ${productName} (Código: ${productCode})`;
    return `https://wa.me/18096318952?text=${encodeURIComponent(message)}`;
  };

  const filteredCategories = selectedCategory === "Todos" ?
  categories :
  categories.filter((cat) => cat.name === selectedCategory);

  const totalProducts = categories.reduce((sum, cat) => sum + cat.products.length, 0);

  return (
    <section className="bg-black py-20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
        </div>

        {/* Category Filter - Desktop: Horizontal Buttons */}
        <div className="hidden md:flex mb-12 flex-wrap justify-center gap-3">
          <button
            onClick={() => setSelectedCategory("Todos")}
            className={`px-6 py-2 rounded-full transition-all ${
            selectedCategory === "Todos" ?
            "bg-white text-black" : "bg-gray-800 text-white hover:bg-gray-700"}`
            }>
            
            Todos ({totalProducts})
          </button>
          {categories.map((category) =>
          <button
            key={category.name}
            onClick={() => setSelectedCategory(category.name)}
            className={`px-6 py-2 rounded-full transition-all ${
            selectedCategory === category.name ?
            "bg-white text-black" : "bg-gray-800 text-white hover:bg-gray-700"}`
            }>
            
              {category.name} ({category.products.length})
            </button>
          )}
        </div>

        {/* Category Filter - Mobile: Dropdown */}
        <div className="md:hidden mb-12">
          <label htmlFor="category-select" className="block text-white text-sm font-semibold mb-2">
            Seleccionar Categoría:
          </label>
          <select
            id="category-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="w-full bg-gray-800 text-white border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:border-white transition-all">
            
            <option value="Todos">Todos ({totalProducts})</option>
            {categories.map((category) =>
            <option key={category.name} value={category.name}>
                {category.name} ({category.products.length})
              </option>
            )}
          </select>
        </div>

        {/* Products Grid */}
        <div className="space-y-16">
          {filteredCategories.map((category) =>
          <div key={category.name}>
              <h3 className="text-3xl font-bold text-white mb-8 border-b border-gray-800 pb-4">
                {category.name}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.products.map((product, index) =>
              <div
                key={`${product.code}-${index}`}
                className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-lg overflow-hidden hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10">
                
                    {/* Product Image */}
                    <div className="bg-white p-6 flex items-center justify-center h-64 overflow-hidden">
                      <AppImage
                    src={product.image}
                    alt={product.alt}
                    className="max-h-full max-w-full object-contain hover-scale-image" />
                  
                    </div>
                    
                    {/* Product Details */}
                    <div className="p-6">
                      <div className="mb-4">
                        <span className="text-gray-500 text-sm font-semibold">
                          CÓDIGO
                        </span>
                        <p className="text-white text-xl font-bold mt-1">
                          {product.code}
                        </p>
                      </div>
                      <div className="mb-4">
                        <span className="text-gray-500 text-sm font-semibold">
                          PRODUCTO
                        </span>
                        <p className="text-white text-lg font-medium mt-1">
                          {product.name}
                        </p>
                      </div>
                      <div className="mb-6">
                        <span className="text-gray-500 text-sm font-semibold">
                          TIPO
                        </span>
                        <p className="text-gray-300 text-sm mt-1">
                          {product.type}
                        </p>
                      </div>
                      
                      {/* Action Buttons */}
                      <div className="space-y-3">
                        <button
                      onClick={() => addToCart(product)}
                      className="block w-full bg-white hover:bg-gray-200 text-black font-bold py-3 px-6 rounded-lg transition-all duration-300 text-center btn-press">
                      
                          Agregar al Carrito
                        </button>
                      </div>
                    </div>
                  </div>
              )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Cart Button and Modal */}
      <CartButton onClick={() => setIsCartOpen(true)} />
      <CartModal isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </section>);

};

export default CompleteCatalogSection;